<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-3">Abbreviations</h1>
<table>
<tbody>
<tr><td class="abbr1"><p class="abbr">AWM Jr.</p></td><td class="abbr2"><p class="abbr">Arthur W. Machan Jr. (Arly) (brother)</p></td></tr>
<tr><td class="abbr1"><p class="abbr">AWM Sr.</p></td><td class="abbr2"><p class="abbr">Arthur Webster Machen (father)</p></td></tr>
<tr><td class="abbr1"><p class="abbr">JGM</p></td><td class="abbr2"><p class="abbr">J. Gresham Machen</p></td></tr>
<tr><td class="abbr1"><p class="abbr">MGM</p></td><td class="abbr2"><p class="abbr">Mary Gresham Machen (mother)</p></td></tr>
<tr><td class="abbr1"><p class="abbr">TGM</p></td><td class="abbr2"><p class="abbr">Tom Gresham Machen (brother)</p></td></tr>
<tr><td class="abbr1"><p class="abbr">WPA</p></td><td class="abbr2"><p class="abbr">William Park Armstrong</p></td></tr>
</tbody>
</table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 008_Abbreviations.vue?22641f78